import React from 'react';
import './CaseStudies.css';
import { theme } from '../../theme/designSystem';
import { caseStudiesData } from '../../data/caseStudiesData';

function CaseStudies() {
    return (
        <section className="case-studies section-pad" id="projects" style={{ backgroundColor: theme.secondary }}>
            <div className="container">
                <div className="case-studies--header">
                    <span className="eyebrow">Selected Work</span>
                    <h2 style={{ color: theme.primary }}>
                        Original contributions of <span className="gradient-text">major significance</span>
                    </h2>
                    <p style={{ color: theme.textSecondary }}>
                        Production systems, not prototypes, at the intersection of federal compliance,
                        large-scale distributed architecture, and applied AI.
                    </p>
                </div>

                <div className="case-studies--body">
                    {caseStudiesData.map((study, index) => (
                        <article
                            className="case-study--card fade-in-up"
                            key={study.id}
                            style={{
                                backgroundColor: theme.cardBg,
                                borderColor: theme.border,
                                animationDelay: `${index * 0.1}s`
                            }}
                        >
                            <div className="case-study--aside">
                                <span className="case-study--tag">{study.tag}</span>
                                <div className="case-study--metric">
                                    <strong style={{ color: theme.accent }}>{study.metric}</strong>
                                    <span style={{ color: theme.textSecondary }}>{study.metricLabel}</span>
                                </div>
                                <div className="case-study--tags">
                                    {study.stack.map((tech, idx) => (
                                        <span key={idx} className="case-study--chip" style={{ color: theme.textSecondary }}>
                                            {tech}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            <div className="case-study--content">
                                <h3 style={{ color: theme.primary }}>{study.title}</h3>
                                <p className="case-study--subtitle" style={{ color: theme.accent }}>{study.subtitle}</p>

                                <div className="case-study--details">
                                    <div className="case-study--section">
                                        <h4>Challenge</h4>
                                        <p style={{ color: theme.textSecondary }}>{study.problem}</p>
                                    </div>
                                    <div className="case-study--section">
                                        <h4>Approach</h4>
                                        <p style={{ color: theme.textSecondary }}>{study.solution}</p>
                                    </div>
                                    <div className="case-study--section">
                                        <h4>Impact</h4>
                                        <p style={{ color: theme.textSecondary }}>{study.impact}</p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default CaseStudies;
